import React, {useState, useEffect} from 'react'
import {useList} from 'store/list'
import * as Icons from 'react-feather';

export default function ListPagination(props) {
   const listStore = useList();
   const currentPerPage = String(listStore.perPage || 15);
   return (<>
      <div className="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-nowrap items-center justify-between">
         <ul className="flex w-full justify-center">
            {listStore.page > 1 &&
            <>
               <li className="p-2">
                  <button type="button" className="pagination__link"
                     onClick={() => props.getList(1)}>
                     <Icons.ChevronsRight className="w-4 h-4"/>
                  </button>
               </li>
               <li className="p-2">
                  <button type="button" className="pagination__link"
                     onClick={() => props.getList(listStore.page - 1)}>
                     <Icons.ChevronRight className="w-4 h-4"/>
                  </button>
               </li>
            </>
            }

            {/* page numbers */}
            {listStore.page > 2 &&
            <>
               <li className={`p-2 ${listStore.page == 1 ? 'pg-active' : ''}`}>
                  <button type="button"
                     className="pagination__link"
                     onClick={() => props.getList(1)}>1
                  </button>
               </li>
               <li className={`p-2 ${listStore.page == 2 ? 'pg-active' : ''}`}>
                  <button type="button" className="pagination__link " onClick={() => props.getList(2)}>2
                  </button>
               </li>
               <li className="p-2"><span className="pagination__link">...</span></li>
            </>
            }

            {listStore.page > 1 && listStore.page < 3 &&
            <li className={`p-2 ${listStore.page == (listStore.page - 1) ? 'pg-active' : ''}`}>
               <button type="button"
                  className="pagination__link"
                  onClick={() => props.getList(listStore.page - 1)}>
                  {listStore.page - 1}
               </button>
            </li>
            }
            <li className={`p-2 ${listStore.page == listStore.page ? 'pg-active' : ''}`}>
               <button type="button"
                  className="pagination__link"
                  onClick={() => props.getList(listStore.page)}>
                  {listStore.page}
               </button>
            </li>

            {listStore.page <= listStore.lastPage - 1 &&
            <li className={`p-2 ${listStore.page == (listStore.page + 1) ? 'pg-active' : ''}`}>
               <button type="button" className="pagination__link"
                  onClick={() => props.getList(listStore.page + 1)}>
                  {listStore.page + 1}
               </button>
            </li>
            }

            {listStore.page <= listStore.lastPage - 2 &&
            <li className={`p-2 ${listStore.page == (listStore.page + 2) ? 'pg-active' : ''}`}>
               <button type="button"
                  className="pagination__link"
                  onClick={() => props.getList(listStore.page + 2)}>
                  {listStore.page + 2}
               </button>
            </li>
            }

            {listStore.page < listStore.lastPage - 2 &&
            <>
               <li className="p-2">
                  <span className="pagination__link">...</span>
               </li>
               <li className={`p-2 ${listStore.page == listStore.lastPage ? 'pg-active' : ''}`}>
                  <button type="button"
                     className="pagination__link"
                     onClick={() => props.getList(listStore.lastPage)}>
                     {listStore.lastPage}
                  </button>
               </li>
            </>
            }
            {/* page numbers */}

            {listStore.page < listStore.lastPage &&
            <>
               <li className="p-2">
                  <button type="button" className="pagination__link"
                     onClick={() => props.getList(listStore.page + 1)}>
                     <Icons.ChevronLeft className="w-4 h-4"/>
                  </button>
               </li>
               <li className="p-2">
                  <button type="button" className="pagination__link"
                     onClick={() => props.getList(listStore.lastPage)}>
                     <Icons.ChevronsLeft className="w-4 h-4"/>
                  </button>
               </li>
            </>
            }
         </ul>
         <select value={currentPerPage} onChange={(e) => (props.getList(1, e.target.value))}
                  className="w-20 form-select box mt-3 sm:mt-0">
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="40">40</option>
            <option value="50">50</option>
         </select>
      </div>

   </>)
}
